import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import CreateTicketModal from '../components/tickets/CreateTicketModal';

const CreateTicketModalContext = createContext(null);

export const CreateTicketModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [createdTicketsVersion, setCreatedTicketsVersion] = useState(0);
  const triggerRef = useRef(null);
  const wasOpenRef = useRef(false);

  const openCreateTicket = useCallback(() => {
    triggerRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    setOpen(true);
  }, []);

  const closeCreateTicket = useCallback(() => {
    setOpen(false);
  }, []);

  const handleCreated = useCallback(() => {
    setCreatedTicketsVersion((version) => version + 1);
  }, []);

  useEffect(() => {
    if (open) {
      wasOpenRef.current = true;
      return;
    }
    if (!wasOpenRef.current) return;
    wasOpenRef.current = false;
    const trigger = triggerRef.current;
    triggerRef.current = null;
    if (trigger && document.contains(trigger)) {
      trigger.focus({ preventScroll: true });
    }
  }, [open]);

  const value = useMemo(
    () => ({ openCreateTicket, closeCreateTicket, createdTicketsVersion }),
    [openCreateTicket, closeCreateTicket, createdTicketsVersion]
  );

  return (
    <CreateTicketModalContext.Provider value={value}>
      {children}
      <CreateTicketModal open={open} onClose={closeCreateTicket} onCreated={handleCreated} />
    </CreateTicketModalContext.Provider>
  );
};

export const useCreateTicketModal = () => {
  const context = useContext(CreateTicketModalContext);
  if (!context) {
    throw new Error('useCreateTicketModal deve ser usado dentro de CreateTicketModalProvider.');
  }
  return context;
};
